import { vn } from 'vend-number'
import { shouldApplyCashDiscountingServiceFee } from '../../../../functions/payments'
import { getOutstandingBalance } from '../../../../functions/sale'
import { useRegisterManager, useSaleManager } from '../../../../ng-compat/hooks'
import { useAppSelector } from '../../../../state/hooks'
import {
  selectCurrentSaleAsSale,
  selectLspCashDiscountPercentage,
} from '../../../../state/slices/currentSale/currentSaleSlice'

export const usePaymentAmountForCashDiscounting = () => {
  const sale = useAppSelector(selectCurrentSaleAsSale)
  const lspCashDiscountPercentage = useAppSelector(
    selectLspCashDiscountPercentage
  )
  const registerManager = useRegisterManager()
  const saleManager = useSaleManager()

  const getPaymentAmountForCashDiscounting = (amountTendered: string) => {
    const tenderedAmountMatchesBalance = vn(amountTendered).eq(
      getOutstandingBalance(sale)
    )
    const hasCashDiscounting = registerManager.hasCashDiscounting()

    // Only adjust the amount tendered when Cash Discounting is enabled, the sale has a positive service fee and the
    // amount tendered matches the outstanding balance. LSPay cash discounting takes priority when both are active.
    if (
      shouldApplyCashDiscountingServiceFee(hasCashDiscounting, {
        totals: sale.totals,
        lspCashDiscountPercentage,
      }) &&
      tenderedAmountMatchesBalance
    ) {
      return saleManager.getCashDiscountedOutstandingBalance()
    }

    return amountTendered
  }

  return { getPaymentAmountForCashDiscounting }
}
